import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Tables {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        const rows = document.querySelectorAll('.click-to-select table tbody tr');
        rows.forEach(row => {
            row.addEventListener('click', e => {
                rows.forEach(row => row.classList.remove('selected'));
                e.currentTarget.classList.add('selected');
            });
        });
   }
}

export default Tables;